import { ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-dc-radio',
  templateUrl: './dc-radio.component.html',
  styleUrls: ['./dc-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DcRadioComponent),
      multi: true,
    },
  ],
})
export class DcRadioComponent implements ControlValueAccessor {
  @Input() name: string;
  @Input() id: string;
  @Input() label: string;
  @Input() selectValue: any;
  @Output() changed = new EventEmitter();

  value: any;

  @ViewChild('inputRef')
  inputRef: ElementRef<HTMLInputElement>;

  onChanged: any = () => {};

  onTouched: any = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (this.inputRef) {
      this.inputRef.nativeElement.checked = this.selectValue === Boolean(this.value);
      if (this.value === null || this.value === undefined) {
        this.writeValue(null);
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.onChanged?.(this.value);
    this.cdr.detectChanges();
  }

}
